import api from './api';

export const budgetService = {
  async getBudgetCategories(weddingId, organizationId) {
    const response = await api.get(`/api/budget/categories?wedding_id=${weddingId}&organization_id=${organizationId}`);
    return response.data;
  },

  async getBudgetCategory(categoryId) {
    const response = await api.get(`/api/budget/categories/${categoryId}`);
    return response.data;
  },

  async createBudgetCategory(weddingId, organizationId, categoryData) {
    const response = await api.post(`/api/budget/categories?wedding_id=${weddingId}&organization_id=${organizationId}`, categoryData);
    return response.data;
  },

  async updateBudgetCategory(categoryId, categoryData) {
    const response = await api.put(`/api/budget/categories/${categoryId}`, categoryData);
    return response.data;
  },

  async deleteBudgetCategory(categoryId) {
    const response = await api.delete(`/api/budget/categories/${categoryId}`);
    return response.data;
  }
};
